import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines an poll answer corresponding to an poll question.
 */
export class PollQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of an poll answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.selectedChoices = bo.selectedChoices;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new PollQuestionAnswerModel(bo);
  }
}
